import { render, staticRenderFns } from "./LexinKeyboardLangRus.vue?vue&type=template&id=00a5a618&"
import script from "./LexinKeyboardLangRus.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangRus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports